<template>
  <div class="card-guide">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <span class="col-2 add-tools" @click="showAddForm">
          + Add Form
        </span>
        <span class="col-2 offset-7">
          <b-form-select
            col="2"
            v-model="selectedFormType"
            :options="formTypeOptions"
            @change="handleFormTypeSelection"
          >
          </b-form-select>
        </span>
        <span class="search">
          <label>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                fill="#B3C2CB"
              />
            </svg>
            <input
              type="search"
              class="search-input"
              placeholder="Search Forms"
              v-model="searchStr"
            /> </label
        ></span>
      </div>
      <div class="tools" role="tablist">
        <b-card no-body>
          <b-table
            id="table-transition-example"
            :items="selectedForms"
            :fields="fields"
            small
            primary-key="a"
            :tbody-transition-props="transProps"
            show-empty
          >
            <template #table-busy>
              Busy
            </template>
            <template #empty="scope">
              No Data Available
            </template>
            <template #cell(imgURL)="row">
              <b-avatar variant="info" :src="row.item.imgURL" class="mr-3" />
            </template>
            <template #cell(show_details)="row">
              <b-icon
                v-if="row.detailsShowing"
                @click="row.toggleDetails"
                icon="chevron-compact-up"
                font-scale="2"
              >
              </b-icon>
              <b-icon
                v-else
                @click="row.toggleDetails"
                icon="chevron-compact-down"
                font-scale="2"
              >
              </b-icon>
            </template>
            <template #row-details="row">
              <b-card>
                <div
                  v-if="
                    row.item.response.questions &&
                      row.item.response.questions.length > 0
                  "
                >
                  <div
                    v-for="(QA, i) in row.item.response.questions"
                    :key="`qa_${i}`"
                  >
                    <b-row class="mb-2">
                      <b-col cols="5">{{
                        row.item.response.questions[i]
                      }}</b-col>
                      <b-col cols="1"> >> </b-col>
                      <b-col cols="6">
                        <a
                          v-if="row.item.response.answers[i].includes('http')"
                          :href="row.item.response.answers[i]"
                        >
                          {{ row.item.response.answers[i] }}
                        </a>
                        <span v-else>
                          {{ row.item.response.answers[i] }}
                        </span>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-card>
            </template>
          </b-table>
        </b-card>
        <b-pagination
          v-model="currentPage"
          :total-rows="selectedForms ? selectedForms.length : 0"
          :per-page="perPage"
          align="left"
          size="sm"
          class="my-0"
        ></b-pagination>
      </div>
      <modal :id="modalName">
        <div class="add-tool" v-if="!del">
          <span class="close-icon" @click="$bvModal.hide(modalName)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>{{ add ? "Add" : "Edit" }} Form</h3>
          <div class="h-18"></div>
          <b-form-group>
            <!-- <b-form-input
              type="text"
              required
              v-model="formFullName"
              placeholder="Full Name"
            ></b-form-input> -->
            <b-form-input
              type="text"
              required
              v-model="formDocumentName"
              placeholder="Form Document Name"
            ></b-form-input>
            <b-form-input
              type="text"
              required
              v-model="formFullName"
              placeholder="Full Name"
            ></b-form-input>
            <b-form-input
              type="text"
              required
              v-model="formType"
              placeholder="Form Type"
            ></b-form-input>
            <!-- <b-form-input
              type="text"
              required
              v-model="formEmail"
              placeholder="Type"
            ></b-form-input> -->
          </b-form-group>
          <!-- <b-form-group class="textarea-scroll"> -->
          <!-- <b-form-textarea
              id="textarea-default"
              rows="8"
              no-resize
              v-model="formPhone"
              placeholder="Enter your answer here"
            ></b-form-textarea> -->
          <!-- </b-form-group> -->

          <div class="d-flex justify-content-between">
            <b-button
              variant="light btn-simple"
              @click="$bvModal.hide(modalName)"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary btn-round-fill "
              v-if="add"
              @click="addForm"
              :disabled="
                formFullName.trim().length > 0 &&
                formDocumentName.trim().length > 0 &&
                formType.trim().length > 0
                  ? false
                  : true
              "
            >
              Add
            </b-button>
            <b-button
              variant="primary btn-round-fill"
              @click="editUser"
              v-else
              :disabled="
                formFullName.trim().length > 0 && formEmail.trim().length > 0
                  ? false
                  : true
              "
            >
              Update
            </b-button>
          </div>
        </div>
        <div class="add-tool del-tool" v-else>
          <span class="close-icon" @click="$bvModal.hide(modalName)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Delete FAQ</h3>
          <div class="warning-msg">
            <p>
              Are you sure want to delete
              <strong>
                {{ tools[activeIndex].q }}
              </strong>
              User?
            </p>
          </div>
          <div class="d-flex justify-content-between">
            <b-button variant="danger btn-round-fill" @click="deleteForm">
              Yes! Delete
            </b-button>
            <b-button variant="light btn-simple" @click="hideDeleteForm">
              No! back
            </b-button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Modal from "@/components/common/modal";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      modalName: "tool-modal",
      notifymodal: "notify-modal",
      searchStr: "",
      add: true,
      del: false,
      input: "",
      activeIndex: -1,
      activeCollapse: -1,
      isJustShown: false,
      formFullName: "",
      formEmail: "",
      formType: "",
      formDocumentName: "",
      // formPhone: "",
      transProps: {
        name: "flip-list"
      },
      fields: [
        {
          key: "user.id",
          label: "User",
          sortable: true
        },
        {
          key: "form.version",
          label: "Version",
          sortable: true
        },
        {
          key: "user.ip",
          label: "IP",
          sortable: true
        },
        {
          key: "_created_at",
          label: "Created",
          sortable: true,
          formatter: "formatDate"
        },
        { key: "show_details", label: "Details" }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
      selectedUser: null,
      showUserNotify: false,
      selectedFormType: null
    };
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Modal
  },
  computed: {
    ...mapGetters({
      formTypes: "forms/formTypes",
      forms: "forms/forms"
    }),
    selectedForms() {
      //console.log("forms", this.forms);
      return this.forms[this.selectedFormType];
    },
    formTypeOptions() {
      let options = [];
      this.formTypes.forEach(aFormType => {
        options.push({ value: aFormType.formId, text: aFormType.formId });
        this.$store.dispatch("forms/getFormsForType", aFormType.formId);
      });
      options.unshift({ value: null, text: "Select Form" });
      return options;
    }
  },
  mounted() {},
  methods: {
    handleActivation() {
      this.handleGetFormTypes();
    },
    handleGetFormTypes(){
      this.$store.dispatch("forms/getFormTypes");
    },
    addForm() {
      let payload = {
        formDocumentName: this.formDocumentName,
        formFullName: this.formFullName,
        formType: this.formType,
        _created_at: new Date()
      };
      this.$store.dispatch("forms/addForm", { payload }).then(() => {
        this.$store
          .dispatch("user/showNotification", {
            title: `New Form Added`,
            description: `You have Added New Form`,
            variant: "success"
          })
          .catch(error => {
            console.log(error);
            this.$store.dispatch("user/showNotification", {
              title: error.code,
              description: error.message,
              variant: "danger"
            });
          });
      });
      this.$bvModal.hide(this.modalName);
      this.formFullName = "";
      this.formDocumentName = "";
      this.formType = "";
      // this.saveChanges();
    },
    editForm() {
      this.tools[this.activeIndex].q = this.formFullName;
      this.tools[this.activeIndex].a = this.formEmail;
      this.$bvModal.hide(this.modalName);
      this.input = "";
      this.saveChanges();
    },
    deleteForm() {
      this.tools.splice(this.activeIndex, 1);
      this.$bvModal.hide(this.modalName);
      this.saveChanges();
    },
    showAddForm() {
      this.del = false;
      this.add = true;
      this.formFullName = "";
      this.formEmail = "";
      this.$bvModal.show(this.modalName);
    },
    showEditUser(i) {
      this.del = false;
      this.add = false;
      this.activeIndex = i;
      this.formFullName = this.tools[i].q;
      this.formEmail = this.tools[i].a;
      this.$bvModal.show(this.modalName);
    },
    showDeleteUser(i) {
      this.del = true;
      this.activeIndex = i;
      this.$bvModal.show(this.modalName);
    },
    hideDeleteForm() {
      this.$bvModal.hide(this.modalName);
    },
    formatDate(date) {
      return date ? moment(date.toDate()).format("MMMM DD, YYYY") : "N/A";
    },
    handleFormTypeSelection(e) {
      this.selectedFormType = e;
      this.$store.dispatch("forms/getFormsForType", e);
    }
  }
};
</script>

<style lang="scss" scoped>
.add-tools {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-tool {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  input {
    margin-top: 48px;
    margin-bottom: 30px;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-tool {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.tools {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }
    border: none;
    box-shadow: none;
    background: none;
  }
}
</style>
